<div id="au_app_footer" class="app-footer">
    <div class="app-container container-xxl d-flex flex-column flex-md-row flex-center py-3 px-0">
        <div class="text-gray-900">
            <span class="px-5 text-dark-bluish-gray" target="_blank">© 2025 Alchemy Underwriting. All rights reserved.</span>
        </div>
    </div>
</div>